import { TZohoModule } from "./ViewInZohoButton";

const prepareZohoUrl = (zohoModule: TZohoModule, zohoId: string) => {
  let url = "https://crm.zoho.com/crm/org638326163/tab/";
  if (zohoModule === "Contact") {
    url += "Contacts/";
  }
  if (zohoModule === "Service") {
    url += "CustomModule17/";
  }
  if (zohoModule === "BankAccount") {
    url += "CustomModule30/";
  }
  if (zohoModule === "ServiceHolder") {
    url += "CustomModule32/";
  }
  if (zohoModule === "Employer") {
    url += "CustomModule16/"
  }

  url += zohoId;
  return url;
};

export { prepareZohoUrl };
